import classes from './loading.module.css';

const Loading = () => (
  <div className={classes.wrapper}>
    <div className={classes.loading_body}>
      <div className={classes.loading}>
        <div className={classes.content}></div>
      </div>
      <div className={classes.text}>Reviewing store data, this could take a minute...</div>
    </div>
  </div>
);
export default Loading;
